<div class="modal-dialog ai-markers-dialog-container">
	<div class="modal-content" cdkTrapFocus>
		<div class="goreact-modal-header">
			<span class="header-label">
				<h4 class="modal-title">
					<i class="ficon-sparkles" aria-hidden="true"></i>
					<span translate="chart_title-ai_prompt"></span>
				</h4>
			</span>
			<button type="button" class="close-btn" (click)="cancel()"
					attr.aria-label="{{ 'common_close' | translate }}">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<section>
			<div class="goreact-modal-body" [ngClass]="{ 'collapsed': (showAi$ | async) === false }">
				<div>{{ 'activity-editor-new_ai-markers-modal-sub-title' | translate }}</div>
				<hr *ngIf="aiLanguageFlag"/>
				<ng-container *ngIf="aiLanguageFlag">
					<div class="section-container transcript-container">
						<div class="container-header">
							<strong>{{ 'feedback-session-feedback-display_transcript-header' | translate }}</strong>
						</div>
						<span class="transcript-language">
						<span
							class="language-label"
							translate="activity-editor-new_ai-markers-modal-transcript-language">
						</span>
						<mat-form-field goSelect>
							<mat-select
								disableOptionCentering
								panelClass="offsetPanel"
								class="language-selector"
								[ngModel]="selectedLanguage$ | async"
								(ngModelChange)="selectedLanguage$.next($event)">
								<mat-option
									*ngFor="let language of languages$ | async"
									[value]="language">
									{{ language.language_name }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</span>
					</div>

				</ng-container>
				<ng-container *ngIf="(loading$ | async) === false; else loading">
					<div class="section-container markers-container"
						 [ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit}">
						<div class="container-header">
							<strong>{{ 'activity-editor-new_ai-markers-modal-ai-markers' | translate }}</strong>
							<div *teaseWall="toggleTeaseConfig; of: loading$">
								<mat-slide-toggle
									(change)="toggleAiMarkers($event)"
									[checked]="true"
									color="primary"
									class="ai-comments-toggle">
									<span *ngIf="showAi$ | async">{{ 'common_on' | translate }}</span>
									<span *ngIf="(showAi$ | async) === false">{{ 'common_off' | translate }}</span>
								</mat-slide-toggle>
							</div>
						</div>
						<p translate="activity-editor-new_ai-markers-modal-description"
						   [translateParams]="{ limit: AiMarkersLimit }">
						</p>

						<ng-container *ngIf="showAi$ | async">
							<div *ngIf="useTypes$ | async" class="use-types-container">
								<mat-form-field goSelect>
									<mat-label>{{ 'activity-editor-new_ai-markers-modal-use-type' | translate }}</mat-label>
									<mat-select
										disableOptionCentering
										panelClass="offsetPanel"
										[ngModel]="useTypeFilter$ | async"
										(selectionChange)="useTypeFilter$.next($event.value)">
										<mat-option
											*ngFor="let u of useTypes$ | async"
											[value]="u.use_type_id">
											{{ u.name }}
										</mat-option>
									</mat-select>
								</mat-form-field>
								<span class="selected-count"
								 	*ngIf="(selectedCount$ | async) > 0"
								 	[ngClass]="{'has-error': (selectedCount$ | async) > AiMarkersLimit }">({{ selectedCount$ | async }})</span>
							</div>

							<div class="markers" [style.overflow-y]="shouldTease ? 'hidden':'auto'">
								<div class="marker-item" *ngFor="let prompt of filteredPrompts$ | async">
									<ng-container *ngIf="!shouldTease">
										<mat-checkbox
											[checked]="(checkedIds$ | async).has(prompt.id)"
											(change)="selectPrompt($event.checked, prompt)"
											aria-label="{{ markerAriaLabel(prompt) }}">
											<marker
												[marker]="markerInput(prompt)"
												[aiStyle]="true"
												[withName]="true">
											</marker>
											<div class="prompt-description">{{ prompt.description }}</div>
										</mat-checkbox>
									</ng-container>

									<ng-container *ngIf="shouldTease">
										<div class="teased-marker-item">
											<div *teaseWall="checkboxTeaseConfig; of: loading$">
												<mat-checkbox
													class="checkbox-to-blur"
													[checked]="(checkedIds$ | async).has(prompt.id)"
													[disabled]="true"
													aria-label="{{ markerAriaLabel(prompt) }}">
												</mat-checkbox>
											</div>
											<div class="marker-and-description">
												<marker
													[marker]="markerInput(prompt)"
													[aiStyle]="true"
													[withName]="true">
												</marker>
												<div class="prompt-description">{{ prompt.description }}</div>
											</div>
										</div>
									</ng-container>
								</div>
							</div>

							<div *ngIf="!shouldTease" class="ai-marker-form-link">
								<span>
									<i class="ficon-lightbulb-o"></i>
									{{ 'activity-editor-new_ai-markers-modal-request-feedback-text' | translate }}
									<a
										href="https://forms.office.com/Pages/ResponsePage.aspx?id=pc7Ek96TuEyKKMAbn5USrIoKGA0eaHdEmMM7pLelNidUOVIwV1NKRlE3TFIxWVI1QTA1OVJROUg3Ni4u"
										target="_blank" rel="noopener noreferrer"
										class="link-btn"
										attr.aria-label="{{'activity-editor-new_ai-markers-modal-request-feedback-link'| translate}}"
										translate="activity-editor-new_ai-markers-modal-request-feedback-link">
									</a>
								</span>
							</div>
						</ng-container>
					</div>
				</ng-container>
				<ng-template #loading>
					<span class="loading-container">
						<span class="ficon-spinner ficon-spin" aria-live="polite"
							  attr.aria-label="{{'common_loading'| translate}}"></span>
					</span>
				</ng-template>
				<div class="validation-error" *ngIf="(selectedCount$ | async) > AiMarkersLimit"
					 translate="activity-editor-new_ai-markers-modal-validation-max_limit"
					 [translateParams]="{ limit: AiMarkersLimit }">
				</div>
			</div>
			<div class="goreact-modal-footer">
				<a *ngIf="shouldTease"
				   [attr.href]="aiMarkerTeaseConfig.secondaryLink"
				   target="_blank"
				   rel="noopener noreferrer"
				   class="link-btn learn-more-link">
					{{ 'access_denied-learn-more' | translate }}
				</a>
				<button class="tertiary-btn cancel-btn" (click)="cancel()" translate="common_cancel"></button>
				<!-- We want to trigger the tease wall button using another button,
				so hide this tease wall button while still keeping it on the DOM -->
				<ng-container *ngIf="shouldTease">
					<div *teaseWall="aiMarkerTeaseConfig" style="display: none;"></div>
				</ng-container>
				<button class="primary-btn save-btn" (click)="handleSaveClick()">
					{{ shouldTease ? (aiMarkerTeaseConfig.translationKey | translate) : ('common_save-and-close' | translate) }}
				</button>
			</div>
		</section>
	</div>
</div>
